<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <globalCheckAccountVue />
  </div>
</template>

<script>
import globalCheckAccountVue from './components/globalCheckAccount.vue'
export default {
  name: 'App',
  components: { globalCheckAccountVue },

  mounted() {
    // if (this.isMobile()) {
    //   this.$router.replace("/homeSchoolConnection");
    // }
    // 路由必须有name，并且不是超管端才调用
    if (!this.$route.fullPath.includes('/background/')) {
      this.$store.dispatch('getStuTitleUrl')
    }
    this.getPageWidth()
    window.addEventListener('resize', this.getPageWidth)
  },
  watch: {
    '$store.state.user.schoolInfo.domain': {
      handler(val) {
        val && this.$store.dispatch('methodSetDetaultPassword')
      },
      immediate: true
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    getPageWidth() {
      document
        .querySelector('body')
        .style.setProperty('--page-width', window.innerWidth + 'px')
    },
  },
}
</script>

<style>
#app {
  font-family: "Avenir, Helvetica, Arial, sans-serif";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #333;
  height: 100%;
}

.el-tabs__nav-wrap::after {
  background-color: #f6f6f6 !important;
}
</style>
